import React, {Component} from 'react';
import PropTypes from 'prop-types';
import withRouter from "react-router/es/withRouter";
import queryString from "query-string";
import ContentRenderer from "../ContentRenderer/ContentRenderer";


class ContentPage extends Component {
  
  contentId = queryString.parse(this.props.location.search).id;
  
  constructor(props) {
    super(props);
    if (!this.isValidPage()) {
      this.props.history.push({
        pathname: this.props.redirectPath
      });
    }
  }
  
  getCurrentContentById = () => {
    return this.props.content[this.props.arrayName].find((content) => {
      return content.id.toString() === this.contentId;
    });
  };
  
  isValidPage = () => {
    const content = this.getCurrentContentById();
    
    if (!content) {
      return false
    }
    
    const hasDetailContent = content.detailContent.value;
    const hasSupportedContentType = content.detailContent.type === ('internal' || 'text/html');
    return content && hasDetailContent && hasSupportedContentType;
  };
  
  getContentView = () => {
    const contentItem = this.getCurrentContentById();
    return (
      <ContentRenderer
        contentType={contentItem.detailContent.type}
        value={contentItem.detailContent.value}
      />
    )
  };
  
  render() {
    return this.getCurrentContentById() ? this.getContentView() : null;
  }
}

export default withRouter(ContentPage);

ContentPage.propTypes = {
  content: PropTypes.any.isRequired,
  arrayName: PropTypes.string.isRequired,
  redirectPath: PropTypes.string.isRequired
};




// WEBPACK FOOTER //
// ./src/components/ContentPage/ContentPage.js